export default __webpack_public_path__ + "static/media/GT-logo.b6254857.png";